import styled, { css } from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const StyledButtonWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 1rem;
  margin-bottom: 3rem;

  ${({ $isAbsolute }) =>
    $isAbsolute &&
    css`
      position: absolute;
      bottom: 1rem;
      left: 0;
      margin-bottom: 0rem;
    `}

  ${themeMedia.desktop`
    position: initial;
    max-width: 350px;
    margin-bottom: 3rem;
  `}
`
